import { useFeatureRollout } from '@rea-argonaut/experiment';
import { usePropertyPageQuery } from '../../../graphql/usePropertyPageQuery';
import { GovernmentDataPartnerBannerWithVariant } from './GovernmentDataPartnerBannerWithVariant';

export const GovernmentDataPartnerBannerWithData = () => {
  const governmentDataPartnerBannerEnabled = useFeatureRollout(
    'government_data_partner_banner',
  ).isEnabled();
  const governmentDataPartnerBannerNTEnabled = useFeatureRollout(
    'government_data_partner_banner_nt',
  ).isEnabled();

  const propertyPage = usePropertyPageQuery()?.data.propertyPageBySlugV3;
  const partnerBanner = propertyPage?.governmentDataV2?.partnerBanner;
  if (!partnerBanner) return null;

  const { partnerBannerVariant, isPropertyNorthernTerritory, state } = partnerBanner;

  if (!governmentDataPartnerBannerEnabled && !isPropertyNorthernTerritory) return null;
  if (!governmentDataPartnerBannerNTEnabled && isPropertyNorthernTerritory) return null;

  return (
    <GovernmentDataPartnerBannerWithVariant
      partnerBannerVariant={partnerBannerVariant}
      isPropertyNorthernTerritory={isPropertyNorthernTerritory}
      state={state}
    />
  );
};
